<template>
  <base-modal v-bind="{ title }" header-class="modal-header-pattern">
    <article class="content" v-html="message"/>
    <div slot="footer" class="buttons">
      <action-button :class="['has-text-weight-bold', 'is-rounded', confirmClass]" @click="$close(true)">{{ confirmText }}</action-button>
      <action-button class="is-light is-rounded" @click="$close(false)">{{ cancelText }}</action-button>
    </div>
  </base-modal>
</template>

<script>
export default {
  props: {
    title: String,
    message: String,
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    confirmClass: {
      type: String|Object,
      default: 'is-success'
    }
  }
}
</script>
